import React from 'react';
import { MdLink } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import { copyToClipboard } from '../../../../legacy/common/utils/clipboard';
import Modal, {
  ModalType
} from '../../../../legacy/common/components/modal/Modal';
import Button, {
  ButtonType
} from '../../../../legacy/common/components/button/Button';

type ShareOrganizationProps = {
  shareLink: string;
  visible: boolean;
  onClose: () => void;
};

const ShareModal: React.FC<ShareOrganizationProps> = ({
  shareLink,
  onClose,
  visible
}) => {
  const { t } = useTranslation(['organizations']);
  const options = [
    {
      id: 'copy-url',
      icon: <MdLink size={24} />,
      label: t('publicView.copyUrl'),
      onClick: () => {
        copyToClipboard(shareLink);
      }
    }
  ];

  return (
    <Modal
      type={ModalType.SMALL}
      onClose={onClose}
      autoHeight
      hideCloseButton
      visible={visible}
    >
      <div className="px-4 pt-6 flex flex-col gap-4">
        {options.map((option) => (
          <Button
            type={ButtonType.Inverted}
            key={option.id}
            icon={option.icon}
            onClick={() => {
              onClose();
              option.onClick();
            }}
          >
            {option.label}
          </Button>
        ))}
      </div>
    </Modal>
  );
};

export default ShareModal;
